import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { TROPHY_DETAILS } from "@/data/trophies";
import useSEO, { BASE_URL, DEFAULT_OG_IMAGE } from "@/hooks/useSEO";

export default function Titulos() {
  useSEO({
    title: "Palmarés · Títulos del C.D. La Bombonera de Barcelona",
    description:
      "Una década forjando títulos. Liga Local 2020/21, Copa Intercontinental 2017, Copa Barcelona 2016, F7A, F7B — todos los campeonatos del club.",
    canonical: `${BASE_URL}/titulos`,
    image: DEFAULT_OG_IMAGE,
  });
  return (
    <main data-testid="titulos-page" className="pt-32 pb-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        <p className="text-[11px] uppercase tracking-[0.3em] text-[#FFB800] mb-6 flex items-center gap-3">
          <span className="h-px w-10 bg-[#FFB800]" />
          Palmarés
        </p>
        <h1 className="font-display text-5xl md:text-7xl lg:text-8xl font-extrabold uppercase tracking-tight leading-[0.9]">
          Una década<br />
          forjando <span className="italic font-light text-white/70">títulos.</span>
        </h1>
        <p className="text-white/60 max-w-2xl mt-8 text-lg leading-relaxed">
          Cinco copas, una identidad. Cada título cuenta una historia escrita
          desde el sacrificio, la entrega y los valores del club.
        </p>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {TROPHY_DETAILS.map((t, i) => (
            <Link
              key={t.slug}
              to={`/titulos/${t.slug}`}
              data-testid={`titulos-card-${t.slug}`}
              className="group relative rounded-[2rem] overflow-hidden bg-[#0A1121] border border-white/8 hover:border-[#FFB800]/40 transition-all duration-500"
            >
              <div className="aspect-[4/5] overflow-hidden">
                <img
                  src={t.cover}
                  alt={t.title}
                  loading="lazy"
                  className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-[#030712] via-[#030712]/40 to-transparent" />
              <div className="absolute top-5 left-5 right-5 flex items-center justify-between">
                <span className="rounded-full bg-[#FFB800] text-[#030712] px-3 py-1 font-mono text-[10px] uppercase tracking-[0.25em] font-bold">
                  {t.year}
                </span>
                <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/60">
                  0{i + 1}
                </span>
              </div>
              <div className="absolute bottom-0 inset-x-0 p-6 flex items-end justify-between gap-3">
                <div className="flex flex-col gap-1">
                  <span className="text-[10px] uppercase tracking-[0.25em] text-[#FFB800]">
                    {t.cat}
                  </span>
                  <span className="font-display text-xl md:text-2xl font-extrabold uppercase tracking-tight text-white group-hover:text-[#FFB800] transition-colors">
                    {t.title}
                  </span>
                </div>
                <span className="h-10 w-10 rounded-full grid place-items-center border border-white/15 group-hover:border-[#FFB800] group-hover:bg-[#FFB800] group-hover:text-[#030712] transition-all flex-shrink-0">
                  <ArrowUpRight size={14} />
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-16">
          <Link
            to="/#palmares"
            data-testid="titulos-home-anchor"
            className="btn-secondary"
          >
            ↳ Ver palmarés en la home
          </Link>
        </div>
      </div>
    </main>
  );
}
